<template>
  <div ref="map"
       class="map-placeholder">
    <a :href="mapLink"
       target="_blank"
       class="map-link"
       rel="noopener">
      <font-awesome-icon
        :icon="['fal', 'map-marked']"
        aria-hidden="true"
        class="icon"></font-awesome-icon>
      <p>
        Click here to view in <br>
        Google Maps
      </p>
    </a>
  </div>
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader";

export default {
  name: "GoogleMapVue",
  props: {
    apiKey: {
      type: String,
      required: true,
    },
    lat: {
      type: Number,
      required: true,
    },
    lng: {
      type: Number,
      required: true,
    },
    zoom: {
      type: Number,
      default: 16,
    },
    version: {
      type: String,
      default: "weekly",
    },
    htmlMarkerLabel: {
      type: String,
      default: "",
    },
    displayMarker: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      gLoader: null,
      map: null,
      marker: null,
      classes: null,
      hasGoogle: false,
    };
  },
  computed: {
    mapLink () {
      return `http://www.google.com/maps/place/${this.lat},${this.lng}`;
    },
  },
  mounted () {
    // set default style if none are given
    this.classes = this.$el.getAttribute( "class" );

    if ( this.isNullOrEmpty( this.classes ) ) {
      this.$el.setAttribute( "id", "gmap" );
    }

    this.gLoader = new Loader( {
      apiKey: this.apiKey,
      version: this.version,
      libraries: ["places"],
    } );

    this.gLoader
      .load()
      .then( () => {
        this.hasGoogle = true;
      } )
      .then( this.renderMap );
  },
  methods: {
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
    renderMap () {
      const mapElement = this.$refs.map;

      if ( this.hasGoogle ) {
        // eslint-disable-next-line no-undef
        this.map = new google.maps.Map( mapElement, {
          center: { lat: this.lat, lng: this.lng },
          zoom: this.zoom,
        } );
      }

      if ( this.displayMarker ) {
        this.marker = this.mapMarker( this.lat, this.lng );

        if ( this.isNullOrEmpty( this.htmlMarkerLabel ) === false && this.marker ) {
          this.initialiseMarkerInfoWindow( this.marker, this.htmlMarkerLabel );
        }
      }
    },
    mapMarker ( lat, lng ) {
      let marker = null;

      if ( this.hasGoogle ) {
        // eslint-disable-next-line no-undef
        marker = new google.maps.Marker( {
          position: { lat, lng },
          map: this.map,
        } );
      }

      return marker;
    },
    initialiseMarkerInfoWindow ( marker, content ) {
      if ( this.hasGoogle ) {
        // eslint-disable-next-line no-undef
        const infowindow = new google.maps.InfoWindow( {
          content,
        } );

        this.marker.addListener( "click", () => {
          infowindow.open( this.map, marker );
        } );
      }
    },
  },
};
</script>
<style lang="less" scoped>
/* Always set the map height explicitly to define the size of the div
       * element that contains the map. */
#gmap {
  min-width: 400px;
  min-height: 400px;
  width: 100%;
  height: 100%;
}

.map-placeholder {
  background-color: #f9f8f7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-link {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  text-decoration: none;

  p {
    margin: 0;
  }
}

.icon {
  font-size: 64px;
  color: #666;
  margin-bottom: 20px;
}

.hidden {
  display: none;
}
</style>
